"use client";
import { Box } from "@mui/material";

import { useStore, observer } from "../../../../../../service/mobx";
import Popup from "../../../../../../component/Popup";
import { PaperCardSize5 } from "../../../../../../component/Card/Paper";
import { CardExternalPaperSize2 } from "../../../../../../component/Card/External";

function AnchorFragment({
  fragment: { href, id, text, highlight, referenceIndex }
}) {
  const { reader } = useStore();
  const internalLink = href[0] === "#";
  const paper = referenceIndex
    ? reader.referencesMap[referenceIndex]
    : undefined;
  const CardForPaper = paper
    ? reader.supportedPublisher.has(paper.publisher)
      ? PaperCardSize5
      : CardExternalPaperSize2
    : undefined;
  const Component = paper
    ? () => (
        <CardForPaper
          paper={paper}
          target="_blank"
          tone="var(--surface-container-lowest)"
        />
      )
    : undefined;

  const Wrapper = Component
    ? referenceIndex || href
      ? Popup
      : PassThrough
    : PassThrough;

  return (
    <Wrapper eventName="Reference" Component={Component}>
      <Box
        tabIndex={-1}
        component="a"
        id={id}
        href={href}
        target={internalLink ? undefined : "_blank"}
        bgcolor={
          highlight
            ? highlight.preview
              ? "colors.primary.50"
              : "colors.highlight"
            : undefined
        }
        sx={{
          wordBreak: "break-all",
          textDecoration: "none",
          cursor: Component ? "pointer" : undefined,
          color:
            Wrapper === PassThrough
              ? "var(--surface-on-color)"
              : "var(--primary-color)"
        }}
        onClick={
          internalLink
            ? event => {
                // const selection = document.getSelection();

                // if (selection.isCollapsed === false) {
                //   selection.removeAllRanges();
                // }

                // reader.scrollTo(href, true);
                event.preventDefault();
                event.stopPropagation();
              }
            : undefined
        }
      >
        {text}
      </Box>
    </Wrapper>
  );
}

export default observer(AnchorFragment);

const PassThrough = props => props.children;
